import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

export function DeptPipeline() {
  const [cards, setCards] = useState([]);
  useEffect(() => { api.get("/hub/pipeline").then((r) => setCards(r.data)).catch(() => {}); }, []);
  if (!cards.length) return null;
  return (
    <div data-testid="dept-pipeline" className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
      {cards.map((c) => (
        <Link key={c.key} to={c.link} data-testid={`pipeline-card-${c.key}`} className="group rounded-2xl border border-zinc-100 bg-white p-4 transition-colors hover:border-[#C5A46D] fade-up">
          <div className="flex items-center justify-between"><span className="text-sm font-extrabold text-zinc-900">{c.title}</span><ArrowRight className="h-4 w-4 text-[#C5A46D] transition-transform group-hover:translate-x-1" /></div>
          <div className="mt-3 flex gap-1">
            {c.stages.map(([s, v], i) => (
              <div key={s} className="min-w-0 flex-1">
                <div className={`h-1.5 rounded-full ${v ? "bg-[#C5A46D]" : "bg-zinc-100"}`} style={{ opacity: v ? 0.45 + (0.55 * (i + 1)) / c.stages.length : 1 }} />
                <div className="mt-1.5 text-lg font-extrabold leading-none text-zinc-900">{v}</div>
                <div className="truncate text-[10px] font-semibold text-zinc-500" title={s}>{s}</div>
              </div>
            ))}
          </div>
          {c.alert && <div className="mt-2 text-[11px] font-bold text-rose-500">{c.alert}</div>}
        </Link>
      ))}
    </div>
  );
}
